import { Alert, Stack } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { FieldboxSelectionGroup } from '@tom-ui/ui'
import { OccupancyType } from '@yard/app/api'
import { JourneyPosition } from '@yard/components/YardPositionSelector/models/journey-position'
import { YardPositionSelector } from '@yard/components/YardPositionSelector/YardPositionSelector'
import { useRef } from 'react'
import { ResolutionActionType } from '../../helpers/yard-issues.helper'
import { FieldboxWithRadio } from '../atoms/FieldboxWithRadio'

export type { ResolutionActionType }

interface Props {
  availableActions: ResolutionActionType[]
  defaultAction?: ResolutionActionType
  targetJourneyId?: number
  onActionChange: (action: ResolutionActionType) => void
  onPositionChange: (position?: JourneyPosition) => void
  onPositionBlockChange?: (isBlocked: boolean) => void
}

export const YardIssueResolutionFormList = ({
  availableActions,
  defaultAction,
  targetJourneyId,
  onActionChange,
  onPositionChange,
  onPositionBlockChange,
}: Props) => {
  const { t } = useTranslate()
  const lastActionRef = useRef<ResolutionActionType | undefined>(defaultAction)

  return (
    <FieldboxSelectionGroup
      defaultValue={defaultAction}
      onSelect={key => {
        const action = key as ResolutionActionType
        if (action === lastActionRef.current) return
        lastActionRef.current = action
        onActionChange(action)
      }}
      options={controller => (
        <>
          {availableActions.includes('createInternalMove') && (
            <FieldboxWithRadio
              selectionKey='createInternalMove'
              controller={controller}
              label={t('createInternalMove', 'Plan an internal move')}
            >
              {targetJourneyId && (
                <Stack>
                  <YardPositionSelector
                    journeyId={targetJourneyId}
                    prefillPosition={OccupancyType.Occupied}
                    onChange={onPositionChange}
                    onBlockingIssueChange={onPositionBlockChange}
                  />

                  <Alert severity='info'>
                    {t(
                      'theIssueWillRemainOpenUntilTheJobIsDone',
                      'The issue will remain open until the job is done',
                    )}
                  </Alert>
                </Stack>
              )}
            </FieldboxWithRadio>
          )}
        </>
      )}
    />
  )
}
